import { createSlice } from "@reduxjs/toolkit";

type SliceState = {
  loading: boolean;
  first: Object;
  userEditData: Object;
  workOrderItemState: any;
  isWorkItem: boolean;
  financialEdit: Object;
};

let initialState: SliceState = {
  loading: false,
  first: {},
  userEditData: {},
  workOrderItemState: [],
  isWorkItem: false,
  financialEdit: {},
};

let uiSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setFirst: (state, action) => {
      const { payload } = action;

      state.first = payload;
    },
    setInitial: (state) => {
      state.first = {};
    },
    setUserState: (state, action) => {
      const { payload } = action;

      state.userEditData = payload;
    },
    setUserInitialState: (state) => {
      state.userEditData = {};
    },
    //-------for workOrderItem-----
    setWorkOrderItemState: (state, action) => {
      const { payload } = action;
      state.workOrderItemState = payload;
    },
    setWorkOrderItemInitialState: (state) => {
      state.workOrderItemState = [];
    },
    setIsworkItem: (state, action) => {
      const { payload } = action;
      state.isWorkItem = payload;
    },
    setInitalIsworkItem: (state) => {
      state.isWorkItem = false;
    },
    //--for edit project finacial info--
    setFinancialEdit: (state, action) => {
      const { payload } = action;

      state.financialEdit = payload;
    },
    setInitialFinancialEdit: (state) => {
      state.financialEdit = {};
    },
  },
  extraReducers: (builder) => {},
});

export const uiSliceActions = uiSlice.actions;

export default uiSlice;
